import { render, staticRenderFns } from "./AddApplyDetail.vue?vue&type=template&id=8b9b37b0&scoped=true&"
import script from "./AddApplyDetail.vue?vue&type=script&lang=js&"
export * from "./AddApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.css?vue&type=style&index=0&id=8b9b37b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9b37b0",
  null
  
)

export default component.exports